import { Injectable } from '@angular/core';
import { CurrentApiService } from 'dbweb-core';
import { HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TaslResultType } from './task';

@Injectable({
	providedIn: 'root'
})
export class TaskService {
	constructor(private taskhttp: CurrentApiService) {}

	GetTaskMessage(): Observable<TaslResultType> {
		return this.taskhttp.get<TaslResultType>('taskinfo');
	}
}
